import { useGlobalStore } from "@/store/GlobalStore";
import { usePictureTopUpStore } from "../../store";
import { useEffect } from "react";
import { BindActivityInfo } from "@/components/top-up/types";
import { useTranslation } from "react-i18next";
import { TopUpSecondTabs } from "@/components/top-up/components/second-tabs";
import { CommonSecondTabsContent } from "../../atom";
import { PictureGiftMember } from "../picture-gift-member";
import { PictureNormalVipRecharge } from "../picture-normal-vip-recharge";

export function PictureVipRecharge({
  activityInfo,
}: {
  activityInfo?: BindActivityInfo;
}) {
  const { isZh } = useGlobalStore();
  const { t } = useTranslation("topup");
  const { setter } = usePictureTopUpStore();
  const vipSecondActiveName = usePictureTopUpStore(
    (state) => state.vipSecondActiveName
  );

  const getVipSecondTabList = () => {
    let list = [];
    list.push(
      activityInfo
        ? {
            label: isZh
              ? activityInfo.activityName
              : activityInfo.activityNameEn,
            key: "second-tab-vip-activity",
            children: <PictureGiftMember activityInfo={activityInfo} />,
          }
        : {
            label: t("topUp_tab_picture"),
            key: "second-tab-vip-normal",
            children: <PictureNormalVipRecharge />,
          }
    );
    return list;
  };

  useEffect(() => {
    setter((state) => {
      state.vipSecondActiveName = getVipSecondTabList()[0].key;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <CommonSecondTabsContent>
        <TopUpSecondTabs
          tabsList={getVipSecondTabList()}
          activeKey={vipSecondActiveName}
          onChange={(k) => {
            setter((state) => {
              state.vipSecondActiveName = k;
            });
          }}
        />
      </CommonSecondTabsContent>
    </div>
  );
}
